module.exports = __webpack_public_path__ + "static/media/logo-small.2cf92467.png";